import rename from "deep-rename-keys";
import camelcase from "lodash.camelcase";

export const apiToState = action => {
  if (action.type.endsWith("_FULFILLED") && action.payload) {
    const data = action.payload.data ? action.payload.data : action.payload;
    const payload = rename(data, key => camelcase(key));

    return { ...action, payload };
  }

  return action;
};

const curriedApiToState = () => next => action => {
  next(apiToState(action));
};

export default curriedApiToState;
